/* eslint-disable perfectionist/sort-imports */
import 'src/global.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import PropTypes from 'prop-types';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';

import Router from 'src/routes/sections';
import ThemeProvider from 'src/theme';
import { useAuth } from './contexts/auth-context';
import { TitleCountProvider } from './contexts/TitleCountContext';
import { FfufCountProvider } from './contexts/FfufCountContext';
import { LiveDomainCountProvider } from './contexts/LiveDomainCountContext';
import { NucleiCountProvider } from './contexts/NucleiCountContext';
import { AclBypassCountProvider } from './contexts/AclBypassCountContext';
import { VulnerabilityFindingsCountProvider } from './contexts/VulnerabilityFindingsCountContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { VhostFindingsCountProvider } from './contexts/VhostFindingsCountContext';
import { SecretsCountProvider } from './contexts/SecretsCountContext';

// ----------------------------------------------------------------------

// Component that only renders its children when user is authenticated
function AuthenticatedProviders({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  
  if (isLoading) {
    return null; // Or a loading indicator
  }
  
  if (!isAuthenticated) {
    return null;
  }
  
  return children;
}

AuthenticatedProviders.propTypes = {
  children: PropTypes.node.isRequired,
};

export default function App() {
  useScrollToTop();
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    // You could show a loading spinner here
    return (
      <ThemeProvider>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          Loading...
        </div>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider>
      {isAuthenticated ? (
        <AuthenticatedProviders>
          <FfufCountProvider>
            <TitleCountProvider>
              <LiveDomainCountProvider>
                <NucleiCountProvider>
                  <AclBypassCountProvider>
                    <VulnerabilityFindingsCountProvider>
                      <VhostFindingsCountProvider>
                        <SecretsCountProvider>
                          <NotificationProvider>
                            <Router />
                          </NotificationProvider>
                        </SecretsCountProvider>
                      </VhostFindingsCountProvider>
                    </VulnerabilityFindingsCountProvider>
                  </AclBypassCountProvider>
                </NucleiCountProvider>
              </LiveDomainCountProvider>
            </TitleCountProvider>
          </FfufCountProvider>
        </AuthenticatedProviders>
      ) : (
        <Router />
      )}
      <ToastContainer />
    </ThemeProvider>
  );
}
